import { lazy } from "react";
import IntroContent from "../../content/IntroContent.json";
import AboutContent from "../../content/AboutContent.json";
import MissionContent from "../../content/MissionContent.json";
import VisionContent from "../../content/VisionContent.json";
import ContactContent from "../../content/ContactContent.json";
import OurServices from '../../components/OurServices';
import OurIndustries from '../../components/OurIndustries';
import VideoBackground from "../../components/VideoBackground/VideoBackground";

const Contact = lazy(() => import("../../components/ContactForm"));
const Container = lazy(() => import("../../common/Container"));
const ScrollToTop = lazy(() => import("../../common/ScrollToTop"));
const ContentBlock = lazy(() => import("../../components/ContentBlock"));
const Card = lazy(() => import("../../components/Card"))

const Home = () => {
  return (
    <>
      <VideoBackground />  {/* Render video outside Container */}
      <Container>
        <ScrollToTop />
        <ContentBlock
          direction="right"
          title={IntroContent.title}
          content={IntroContent.text}
          button={IntroContent.button}
          icon="developer.svg"
          id="intro"
        />
        <ContentBlock
          direction="left"
          title={AboutContent.title}
          content={AboutContent.text}
          section={AboutContent.section}
          id="about"
        />
        <ContentBlock
          direction="right"
          title={MissionContent.title}
          content={MissionContent.text}
          icon="product-launch.svg"
          id="mission"
        />
        <ContentBlock
          direction="left"
          title={VisionContent.title}
          content={VisionContent.text}
          icon="waving.svg"
          id="vision"
        />
        <OurServices/>
        <OurIndustries/>
        <Card id="product" />
        <Contact
          title={ContactContent.title}
          content={ContactContent.text}
          id="contact"
        />
      </Container>
    </>
  );
};

export default Home;
